import sadSERPUrlsToHappyCanonicals from './static/sad-serp-urls-to-happy-canonicals.json'

const sadSERPPathsAndQueriesToHappyCanonicals = Object.entries(sadSERPUrlsToHappyCanonicals).reduce(
  (map, [rawSadSERPUrl, happyCanonical]) => {
    const { pathname, searchParams } = new URL(rawSadSERPUrl)
    const q = searchParams.get('q')
    if (!pathname || !q) throw new Error(`Malformed sad SERP url: ${rawSadSERPUrl}`)

    return map.set(`${pathname}?q=${q}`.toLocaleLowerCase(), happyCanonical)
  },
  new Map()
)

/**
 * @description Function that returns a valid pre existing canonical URL mapped to a raw SERP URL.
 * @param rawSadSERPUrl raw SERP url used to find the valid one in the map.
 */
export const getHappyCanonical = (rawSadSERPUrl: string): string =>
  sadSERPPathsAndQueriesToHappyCanonicals.get(rawSadSERPUrl)
